export default __webpack_public_path__ + "static/media/photo--lg--daniel-3.b2ef04f2.jpg";